import { Route } from "react-router-dom";
import ProgramManagerMain from "../../screens/program_manager/ProgramManagerMain";
import ProgramDetails from "../../screens/program_manager/ProgramDetails";
import CreateProgramForm from "../../screens/program_manager/CreateProgramForm";
import AddTask from "../../screens/program_manager/AddTask";

export const programManagerRoutes = [
  <Route
    key="program-manager-home"
    path="/"
    element={<ProgramManagerMain />}
  />,
  <Route
    key="program-manager-details"
    path="/program/:programId"
    element={<ProgramDetails />}
  />,
  <Route
    key="program-manager-create"
    path="/create-program"
    element={<CreateProgramForm />}
  />,
  <Route
    key="program-manager-add-tasks"
    path="/programs/:programId/add-tasks"
    element={<AddTask />}
  />,
];
